import { render, staticRenderFns } from "./comp_AboutWhisky-B-Origins.vue?vue&type=template&id=a13899ec&scoped=true&"
import script from "./comp_AboutWhisky-B-Origins.vue?vue&type=script&lang=js&"
export * from "./comp_AboutWhisky-B-Origins.vue?vue&type=script&lang=js&"
import style0 from "./comp_AboutWhisky-B-Origins.vue?vue&type=style&index=0&id=a13899ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13899ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
